import icon from '../../assets/svg/财务明细.svg';
import type { RouteConfig } from '@/types/route';

export const routeConfig: RouteConfig = {
    title: 'route.financialDetails',
    icon:  <img src={icon} alt="Financial Details" className="w-4 h-4" />,
    layout: true,
    sort: 4
};